import { useParams, Link, Navigate } from "react-router-dom";
import { useSeo } from "@/lib/seo";
import { Reveal } from "@/components/Reveal";
import { blogMap } from "@/data/content";
import { ArrowLeft } from "lucide-react";

export default function BlogPost() {
  const { slug } = useParams();
  const post = blogMap[slug];
  useSeo({
    title: post?.title,
    description: post?.excerpt,
  });
  if (!post) return <Navigate to="/blog" replace />;

  return (
    <article className="bg-[#0D1B2A]">
      <section className="pt-20 pb-16 border-b border-white/5 relative noise-overlay">
        <div className="max-w-3xl mx-auto px-5 lg:px-8 relative z-10">
          <Link to="/blog" className="inline-flex items-center gap-2 text-sm text-gray-400 hover:text-[#C5A059]">
            <ArrowLeft size={15} /> Tutte le risorse
          </Link>
          <div className="flex items-center gap-3 mt-8">
            <span className="label-eyebrow">{post.category}</span>
            <span className="text-xs text-gray-500">· {post.date}</span>
          </div>
          <Reveal>
            <h1 className="font-display font-light text-3xl lg:text-5xl text-white mt-4 leading-tight">
              {post.title}
            </h1>
          </Reveal>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-3xl mx-auto px-5 lg:px-8">
          {post.body.map((par, i) => (
            <p key={i} className="text-gray-300 text-lg leading-relaxed mb-6">
              {par}
            </p>
          ))}
          <div className="border border-[#C5A059]/20 bg-[#1E2229] p-6 mt-10">
            <p className="text-sm text-gray-400 leading-relaxed">
              <strong className="text-gray-200">Nota.</strong> Contenuto a scopo informativo, non
              costituisce consulenza legale o fiscale. Per il tuo caso specifico, rivolgiti a un
              professionista abilitato.
            </p>
          </div>
          <div className="mt-10">
            <Link to="/contatti" className="inline-block bg-[#C5A059] text-[#0D1B2A] hover:bg-[#D8B978] transition-colors font-medium px-8 py-4">
              Hai una domanda? Parliamone
            </Link>
          </div>
        </div>
      </section>
    </article>
  );
}
